var storeID;
// storeID = storeID.split('=')[1];

console.log(window.location.href.split("/").pop());
var storeLocation = window.location.href.split("/").pop();
storeLocation = storeLocation.split("?")[0];

if (storeLocation == "travel-money-acocks-green") { storeID = 6414 }
else if (storeLocation == "travel-money-acomb") { storeID = 6415 }
else if (storeLocation == "travel-money-acton") { storeID = 6935 }
else if (storeLocation == "travel-money-ashton-under-lyne") { storeID = 6416 }
else if (storeLocation == "travel-money-ayr") { storeID = 6703 }
else if (storeLocation == "travel-money-barking") { storeID = 6123 }
else if (storeLocation == "travel-money-barkingside") { storeID = 6417 }
else if (storeLocation == "travel-money-barnsley") { storeID = 6418 }
 else if (storeLocation == "travel-money-basingstoke") { storeID = 6855 } 
else if (storeLocation == "travel-money-basildon") { storeID = 6603 }
else if (storeLocation == "travel-money-bearwood") { storeID = 6852 }
else if (storeLocation == "travel-money-bedford") { storeID = 6419 }
else if (storeLocation == "travel-money-bedminster") { storeID = 6969 }
else if (storeLocation == "travel-money-belle-vale") { storeID = 6831 }
else if (storeLocation == "travel-money-berkeley-square") { storeID = 6838 }
else if (storeLocation == "travel-money-beaumont-leys") { storeID = 6854 }  
else if (storeLocation == "travel-money-bexleyheath") { storeID = 6948 }
else if (storeLocation == "travel-money-birkenhead") { storeID = 6713 }
else if (storeLocation == "travel-money-birmingham-bull-street") { storeID = 6949 }
else if (storeLocation == "travel-money-birmingham-ethel-street") { storeID = 6201 }
else if (storeLocation == "travel-money-birmingham-northfield") { storeID = 6827 }
else if (storeLocation == "travel-money-birmingham-soho-road") { storeID = 6925 }
else if (storeLocation == "travel-money-blackburn") { storeID = 6309 }
else if (storeLocation == "travel-money-blackpool") { storeID = 6240 }
else if (storeLocation == "travel-money-bletchley") { storeID = 6420 }
else if (storeLocation == "travel-money-bolton-great-moor-street") { storeID = 6421 }
else if (storeLocation == "travel-money-bolton-newport-street") { storeID = 6407 }
else if (storeLocation == "travel-money-bootle") { storeID = 6401 }
else if (storeLocation == "travel-money-borehamwood") { storeID = 6422 }
else if (storeLocation == "travel-money-boston") { storeID = 6841 }
else if (storeLocation == "travel-money-bow") { storeID = 6130 }
else if (storeLocation == "travel-money-bradford-james-street") { storeID = 6847 }
else if (storeLocation == "travel-money-bradford-hustlergate") { storeID = 6848 }
else if (storeLocation == "travel-money-bradford") { storeID = 6207 }
else if (storeLocation == "travel-money-breck-road") { storeID = 6823 }
else if (storeLocation == "travel-money-bridgwater") { storeID = 6423 }
else if (storeLocation == "travel-money-brighton") { storeID = 6117 }
else if (storeLocation == "travel-money-brixton") { storeID = 6944 }
else if (storeLocation == "travel-money-bromley") { storeID = 6959 }
else if (storeLocation == "travel-money-burnley") { storeID = 6424 }
else if (storeLocation == "travel-money-burnt-oak-broadway") { storeID = 6425 }
else if (storeLocation == "travel-money-burnt-oak") { storeID = 6107 }
else if (storeLocation == "travel-money-burton-on-trent") { storeID = 6426 }
else if (storeLocation == "travel-money-camberwell") { storeID = 6931 }
else if (storeLocation == "travel-money-cambridge") { storeID = 6427 }
else if (storeLocation == "travel-money-camden") { storeID = 6839 }
else if (storeLocation == "travel-money-canning-town") { storeID = 6428 }
else if (storeLocation == "travel-money-canterbury") { storeID = 6429 }
else if (storeLocation == "travel-money-cardiff-canton") { storeID = 6843 }
else if (storeLocation == "travel-money-cardiff") { storeID = 6483 }
else if (storeLocation == "travel-money-catford") { storeID = 6102 }
else if (storeLocation == "travel-money-chalk-farm") { storeID = 6134 }
else if (storeLocation == "travel-money-chatham") { storeID = 6607 }
else if (storeLocation == "travel-money-chatham2") { storeID = 6829 }
else if (storeLocation == "travel-money-cheetham-hill") { storeID = 6960 }
else if (storeLocation == "travel-money-chelmsford") { storeID = 6924 }
else if (storeLocation == "travel-money-chelmsley-wood") { storeID = 6828 }
else if (storeLocation == "travel-money-chesterfield") { storeID = 6846 }
else if (storeLocation == "travel-money-clacton-on-sea") { storeID = 6430 }
else if (storeLocation == "travel-money-clapham-high-street") { storeID = 6477 }
else if (storeLocation == "travel-money-clapham") { storeID = 6104 }
else if (storeLocation == "travel-money-clapton") { storeID = 6131 }
else if (storeLocation == "travel-money-clydebank") { storeID = 6403 }
else if (storeLocation == "travel-money-colchester") { storeID = 6918 }
else if (storeLocation == "travel-money-corby") { storeID = 6508 }
else if (storeLocation == "travel-money-cosham") { storeID = 6710 }
else if (storeLocation == "travel-money-county-road") { storeID = 6803 }
else if (storeLocation == "travel-money-coventry-hales-street") { storeID = 6215 }
else if (storeLocation == "travel-money-coventry-lower-precinct") { storeID = 6909 }
else if (storeLocation == "travel-money-coventry-walsgrave-road") { storeID = 6868 }
else if (storeLocation == "travel-money-crawley") { storeID = 6712 }
else if (storeLocation == "travel-money-crewe") { storeID = 6987 }
else if (storeLocation == "travel-money-croydon-east") { storeID = 6945 }
else if (storeLocation == "travel-money-croydon-northend") { storeID = 6938 }
else if (storeLocation == "travel-money-cumbernauld") { storeID = 6431 }
else if (storeLocation == "travel-money-cwmbran") { storeID = 6833 }
else if (storeLocation == "travel-money-dagenham") { storeID = 6311 }
else if (storeLocation == "travel-money-dalston") { storeID = 6115 }
else if (storeLocation == "travel-money-dalston-formally-mybond") { storeID = 6849 }
else if (storeLocation == "travel-money-darlington") { storeID = 6801 }
else if (storeLocation == "travel-money-dartford") { storeID = 6196 }
else if (storeLocation == "travel-money-deptford") { storeID = 6106 }
else if (storeLocation == "travel-money-derby") { storeID = 6907 }
else if (storeLocation == "travel-money-doncaster") { storeID = 6705 }
else if (storeLocation == "travel-money-dover") { storeID = 6432 }
else if (storeLocation == "travel-money-dovercourt") { storeID = 6861 }
else if (storeLocation == "travel-money-downham") { storeID = 6930 }
else if (storeLocation == "travel-money-dudley") { storeID = 6220 }
else if (storeLocation == "travel-money-dundee") { storeID = 6303 }
else if (storeLocation == "travel-money-dunstable") { storeID = 6433 }
else if (storeLocation == "travel-money-eastbourne") { storeID = 6866 }
else if (storeLocation == "travel-money-east-ham") { storeID = 6932 }
else if (storeLocation == "travel-money-eastern-avenue") { storeID = 6856 }
else if (storeLocation == "travel-money-east-kilbride") { storeID = 6605 }
else if (storeLocation == "travel-money-easterhouse") { storeID = 6405 }
else if (storeLocation == "travel-money-eastleigh") { storeID = 6913 }
else if (storeLocation == "travel-money-edgware") { storeID = 6434 }
else if (storeLocation == "travel-money-edinburgh-lauriston-place") { storeID = 6301 }
else if (storeLocation == "travel-money-edinburgh-nicholson-street") { storeID = 6923 }
else if (storeLocation == "travel-money-edinburgh-queen-street") { storeID = 6825 }
else if (storeLocation == "travel-money-edmonton-fore-street") { storeID = 6997 }
else if (storeLocation == "travel-money-edmonton-south-mall") { storeID = 6929 }
else if (storeLocation == "travel-money-ellesmere-port") { storeID = 6714 }
else if (storeLocation == "travel-money-eltham") { storeID = 6906 }
else if (storeLocation == "travel-money-enfield") { storeID = 6435 }
else if (storeLocation == "travel-money-erdington") { storeID = 6436 }
else if (storeLocation == "travel-money-fareham") { storeID = 6805 }
else if (storeLocation == "travel-money-feltham") { storeID = 6851 }
else if (storeLocation == "travel-money-felixstowe") { storeID = 6860 }
else if (storeLocation == "travel-money-finsbury") { storeID = 6116 }
else if (storeLocation == "travel-money-forest-gate") { storeID = 6977 }
else if (storeLocation == "travel-money-fulham") { storeID = 6108 }
else if (storeLocation == "travel-money-gateshead") { storeID = 6908 }
else if (storeLocation == "travel-money-gillingham") { storeID = 6113 }
else if (storeLocation == "travel-money-glasgow-bath-street") { storeID = 6304 }
else if (storeLocation == "travel-money-glasgow-duke-street") { storeID = 6928 }
else if (storeLocation == "travel-money-glasgow-great-western-road") { storeID = 6814 }
else if (storeLocation == "travel-money-gloucester") { storeID = 6842 }
else if (storeLocation == "travel-money-golders-green") { storeID = 6437 }
else if (storeLocation == "travel-money-govan") { storeID = 6302 }
else if (storeLocation == "travel-money-gravesend") { storeID = 6608 }
else if (storeLocation == "travel-money-grays") { storeID = 6438 }
else if (storeLocation == "travel-money-great-bridge") { storeID = 6950 }
else if (storeLocation == "travel-money-green-lanes") { storeID = 6850 }
else if (storeLocation == "travel-money-green-street") { storeID = 6985 }
else if (storeLocation == "travel-money-greenock") { storeID = 6406 }
else if (storeLocation == "travel-money-grimsby") { storeID = 6934 }
else if (storeLocation == "travel-money-hackney") { storeID = 6964 }
else if (storeLocation == "travel-money-halifax") { storeID = 6439 }
else if (storeLocation == "travel-money-hamilton") { storeID = 6440 }
else if (storeLocation == "travel-money-hammersmith") { storeID = 6121 }
else if (storeLocation == "travel-money-harlesden") { storeID = 6961 }
else if (storeLocation == "travel-money-harlow") { storeID = 6921 }
else if (storeLocation == "travel-money-harrow-st-anns-road") { storeID = 6992 }
else if (storeLocation == "travel-money-harrow-station-road") { storeID = 6915 }
else if (storeLocation == "travel-money-harrow") { storeID = 6442 }
else if (storeLocation == "travel-money-hastings") { storeID = 6312 }
else if (storeLocation == "travel-money-hatfield") { storeID = 6443 }
else if (storeLocation == "travel-money-hayes-coldharbour-lane") { storeID = 6444 }
else if (storeLocation == "travel-money-hayes") { storeID = 6952 }
else if (storeLocation == "travel-money-hemel-hempstead") { storeID = 6445 }
else if (storeLocation == "travel-money-hillsborough") { storeID = 6853 }
else if (storeLocation == "travel-money-holloway") { storeID = 6984 }
else if (storeLocation == "travel-money-hounslow-central") { storeID = 6995 }
else if (storeLocation == "travel-money-hounslow") { storeID = 6119 }
else if (storeLocation == "travel-money-huddersfield") { storeID = 6446 }
else if (storeLocation == "travel-money-hull") { storeID = 6937 }
else if (storeLocation == "travel-money-huyton") { storeID = 6447 }
else if (storeLocation == "travel-money-hyde") { storeID = 6810 }
else if (storeLocation == "travel-money-ilford-high-road") { storeID = 6983 }
else if (storeLocation == "travel-money-ilford") { storeID = 6132 }
else if (storeLocation == "travel-money-ipswich") { storeID = 6448 }
else if (storeLocation == "travel-money-ipswich-2") { storeID = 6859 }
else if (storeLocation == "travel-money-irvine") { storeID = 6602 }
else if (storeLocation == "travel-money-islington") { storeID = 6844 }
else if (storeLocation == "travel-money-kidderminster") { storeID = 6449 }
else if (storeLocation == "travel-money-kilburn-bridge") { storeID = 6451 }
else if (storeLocation == "travel-money-kilburn-high-road") { storeID = 6450 }
else if (storeLocation == "travel-money-kilburn") { storeID = 6936 }
else if (storeLocation == "travel-money-kings-lynn") { storeID = 6837 }
else if (storeLocation == "travel-money-kingstanding") { storeID = 6452 }
else if (storeLocation == "travel-money-kingston") { storeID = 6956 }
else if (storeLocation == "travel-money-kirkby") { storeID = 6402 }
else if (storeLocation == "travel-money-kirkcaldy") { storeID = 6413 }
else if (storeLocation == "travel-money-leeds-harehills") { storeID = 6441 }
else if (storeLocation == "travel-money-leeds-bramley") { storeID = 6857 }
else if (storeLocation == "travel-money-leeds") { storeID = 6904 }
else if (storeLocation == "travel-money-leeds-merrion") { storeID = 6858 }
else if (storeLocation == "travel-money-leicester") { storeID = 6505 }
else if (storeLocation == "travel-money-leigh") { storeID = 6804 }
else if (storeLocation == "travel-money-leith") { storeID = 6806 }
else if (storeLocation == "travel-money-levenshulme") { storeID = 6453 }
else if (storeLocation == "travel-money-lewisham") { storeID = 6942 }
else if (storeLocation == "travel-money-leyton") { storeID = 6114 }
else if (storeLocation == "travel-money-liverpool") { storeID = 6230 }
else if (storeLocation == "travel-money-livingston") { storeID = 6411 }
else if (storeLocation == "travel-money-longsight") { storeID = 6481 }
else if (storeLocation == "travel-money-luton") { storeID = 6506 }
else if (storeLocation == "travel-money-macclesfield") { storeID = 6408 }
else if (storeLocation == "travel-money-maidstone") { storeID = 6454 }
else if (storeLocation == "travel-money-mansfield") { storeID = 6455 }
else if (storeLocation == "travel-money-margate") { storeID = 6980 }
else if (storeLocation == "travel-money-merthyr-tydfil") { storeID = 6836 }
else if (storeLocation == "travel-money-middlesbrough") { storeID = 6922 }
else if (storeLocation == "travel-money-middleton") { storeID = 6865 }
else if (storeLocation == "travel-money-new-addington") { storeID = 6955 }
else if (storeLocation == "travel-money-newcastle-clayton-street") { storeID = 6305 }
else if (storeLocation == "travel-money-newcastle-grainger-street") { storeID = 6927 }
else if (storeLocation == "travel-money-newcastle-west-road") { storeID = 6486 }
else if (storeLocation == "travel-money-newport") { storeID = 6457 }
else if (storeLocation == "travel-money-northampton-regent-square") { storeID = 6461 }
else if (storeLocation == "travel-money-northampton") { storeID = 6914 }
else if (storeLocation == "travel-money-norwich") { storeID = 6458 }
else if (storeLocation == "travel-money-nottingham") { storeID = 6917 }
else if (storeLocation == "travel-money-oldham-spindles-shopping-centre") { storeID = 6821 }
else if (storeLocation == "travel-money-orpington") { storeID = 6809 }
else if (storeLocation == "travel-money-oxford") { storeID = 6485 }
else if (storeLocation == "travel-money-paddington") { storeID = 6133 }
else if (storeLocation == "travel-money-partick") { storeID = 6310 }
else if (storeLocation == "travel-money-perry-barr") { storeID = 6864 }
else if (storeLocation == "travel-money-peckham") { storeID = 6105 }
else if (storeLocation == "travel-money-penge") { storeID = 6967 }
else if (storeLocation == "travel-money-peterborough-lincoln-road") { storeID = 6459 }
else if (storeLocation == "travel-money-peterborough") { storeID = 6916 }
else if (storeLocation == "travel-money-plaistow") { storeID = 6826 }
else if (storeLocation == "travel-money-plymouth") { storeID = 6830 }
else if (storeLocation == "travel-money-pontypridd") { storeID = 6834 }
else if (storeLocation == "travel-money-poplar") { storeID = 6103 }
else if (storeLocation == "travel-money-portsmouth") { storeID = 6709 }
else if (storeLocation == "travel-money-preston") { storeID = 6911 }
else if (storeLocation == "travel-money-queens-park") { storeID = 6484 }
else if (storeLocation == "travel-money-ramsgate") { storeID = 6460 }
else if (storeLocation == "travel-money-reading") { storeID = 6901 }
/*else if (storeLocation == "travel-money-rochdale-baillie-street") { storeID = 6462 }*/
else if (storeLocation == "travel-money-rochdale") { storeID = 6811 }
else if (storeLocation == "travel-money-romford") { storeID = 6940 }
else if (storeLocation == "travel-money-rose-hill") { storeID = 6478 }
else if (storeLocation == "travel-money-rotherham") { storeID = 6706 }
else if (storeLocation == "travel-money-rugby") { storeID = 6606 }
else if (storeLocation == "travel-money-runcorn") { storeID = 6400 }
else if (storeLocation == "travel-money-rutherglen") { storeID = 6404 }
else if (storeLocation == "travel-money-salford") { storeID = 6409 }
else if (storeLocation == "travel-money-scunthorpe") { storeID = 6905 }
else if (storeLocation == "travel-money-shawlands") { storeID = 6463 }
else if (storeLocation == "travel-money-sheerness") { storeID = 6835 }
else if (storeLocation == "travel-money-sheffield-king-street") { storeID = 6464 }
else if (storeLocation == "travel-money-sheffield") { storeID = 6707 }
else if (storeLocation == "travel-money-shepherds-bush") { storeID = 6482 }
else if (storeLocation == "travel-money-sidcup") { storeID = 6951 }
else if (storeLocation == "travel-money-sittingbourne") { storeID = 6465 }
else if (storeLocation == "travel-money-slough") { storeID = 6122 }
else if (storeLocation == "travel-money-southall") { storeID = 6954 }
else if (storeLocation == "travel-money-southampton-est") { storeID = 6820 }
else if (storeLocation == "travel-money-southampton") { storeID = 6920 }
else if (storeLocation == "travel-money-southend") { storeID = 6974 }
else if (storeLocation == "travel-money-springburn") { storeID = 6503 }
else if (storeLocation == "travel-money-st-helens") { storeID = 6609 }
else if (storeLocation == "travel-money-stevenage") { storeID = 6957 }
else if (storeLocation == "travel-money-stirling") { storeID = 6812 }
else if (storeLocation == "travel-money-stockport") { storeID = 6410 }
else if (storeLocation == "travel-money-stockton") { storeID = 6807 }
else if (storeLocation == "travel-money-stoke") { storeID = 6903 }
else if (storeLocation == "travel-money-stratford") { storeID = 6968 }
else if (storeLocation == "travel-money-streatham") { storeID = 6127 }
else if (storeLocation == "travel-money-stretford") { storeID = 6205 }
else if (storeLocation == "travel-money-sunderland") { storeID = 6813 }
else if (storeLocation == "travel-money-surrey-quays") { storeID = 6124 }
else if (storeLocation == "travel-money-sutton-in-ashfield") { storeID = 6943 }
else if (storeLocation == "travel-money-sutton") { storeID = 6120 }
else if (storeLocation == "travel-money-sutton-2") { storeID = 6870 }
else if (storeLocation == "travel-money-swansea") { storeID = 6840 }
else if (storeLocation == "travel-money-swindon") { storeID = 6910 }
else if (storeLocation == "travel-money-staines") { storeID = 6869 }
else if (storeLocation == "travel-money-sydenham") { storeID = 6965 }
else if (storeLocation == "travel-money-tooting-junction") { storeID = 6711 }
else if (storeLocation == "travel-money-tooting") { storeID = 6111 }
else if (storeLocation == "travel-money-tottenham") { storeID = 6926 }
else if (storeLocation == "travel-money-uxbridge") { storeID = 6946 }
else if (storeLocation == "travel-money-wallsend") { storeID = 6802 }
else if (storeLocation == "travel-money-walsall") { storeID = 6202 }
else if (storeLocation == "travel-money-waltham-cross") { storeID = 6467 }
else if (storeLocation == "travel-money-walthamstow") { storeID = 6128 }
else if (storeLocation == "travel-money-walton-vale") { storeID = 6507 }
else if (storeLocation == "travel-money-walworth-road-2") { storeID = 6993 }
else if (storeLocation == "travel-money-walworth") { storeID = 6101 }
else if (storeLocation == "travel-money-ward-end") { storeID = 6468 }
else if (storeLocation == "travel-money-warrington") { storeID = 6845 }
else if (storeLocation == "travel-money-waterloo") { storeID = 6993 }
else if (storeLocation == "travel-money-watford") { storeID = 6701 }
else if (storeLocation == "travel-money-welling") { storeID = 6307 }
else if (storeLocation == "travel-money-wellingborough") { storeID = 6469 }
else if (storeLocation == "travel-money-wembley") { storeID = 6808 }
else if (storeLocation == "travel-money-west-bromwich-kings-square") { storeID = 6939 }
else if (storeLocation == "travel-money-west-bromwich-st-michael-street") { storeID = 6824 }
else if (storeLocation == "travel-money-west-croydon") { storeID = 6982 }
else if (storeLocation == "travel-money-wester-hailes") { storeID = 6832 }
else if (storeLocation == "travel-money-widnes") { storeID = 6470 }
else if (storeLocation == "travel-money-wigan") { storeID = 6412 }
else if (storeLocation == "travel-money-willesden-walm-lane") { storeID = 6471 }
else if (storeLocation == "travel-money-willesden") { storeID = 6109 }
else if (storeLocation == "travel-money-wisbech") { storeID = 6472 }
else if (storeLocation == "travel-money-woking") { storeID = 6473 }
else if (storeLocation == "travel-money-wolverhampton-darlington-street") { storeID = 6474 }
else if (storeLocation == "travel-money-wolverhampton-queen-street") { storeID = 6973 }
else if (storeLocation == "travel-money-wolverhampton") { storeID = 6702 }
else if (storeLocation == "travel-money-wood-green") { storeID = 6501 }
else if (storeLocation == "travel-money-woolwich-beresford-square") { storeID = 6476 }
else if (storeLocation == "travel-money-woolwich-greens-end") { storeID = 6475 }
else if (storeLocation == "travel-money-woolwich") { storeID = 6919 }
else if (storeLocation == "travel-money-worcester-park") { storeID = 6966 }
else if (storeLocation == "travel-money-worksop") { storeID = 6708 }
else if (storeLocation == "travel-money-worthing") { storeID = 6867 }
else if (storeLocation == "travel-money-wythenshawe") { storeID = 6902 }
else if (storeLocation == "travel-money-bury") { storeID = 6872 }
else if (storeLocation == "travel-money-bransholme") { storeID = 6875 }


console.log('Store ID: ',storeID)
console.log('Store Location: ',storeLocation)
var allDataPerStore_api = "https://as-handt-store-address-service.azurewebsites.net/api/AllDataPerStore/"+storeID;
var nearestShop_api = "https://as-handt-store-address-service.azurewebsites.net/api/NearestStore";
var map_api = "https://as-handt-store-address-service.azurewebsites.net/api/EmbedMap";

$(document).ready(function(){
  //bind map
  var mapAjaxSettings = {
    "async": true,
    "crossDomain": true,
    "url": map_api+"/"+storeID,
    "method": "GET"
  }
  $.ajax(mapAjaxSettings).done(function (response) {
    //$('.map-container').html(response)
  });

  //bind store details
  var storeDetailsAjaxSettings = {
    "async": true,
    "crossDomain": true,
    "url": allDataPerStore_api,
    "method": "GET"
  }
  $.ajax(storeDetailsAjaxSettings).done(function (response) {
    $('.store-details-top-info .store-name').text(response.storeName);    
    $('.store-details-top-info .store-direction').attr('href','https://www.google.com/maps/dir/Current+Location/'+response.storeLatitude+','+response.storeLongitude+''); 
    $('.store-details-top-info .store-fulladdress').html(response.storeAddress+'<br>'+response.storePostcode); 
    $('.store-details-top-info .store-phonenumber').html("<a href='tel:"+response.storeTelephone1+"'>"+response.storeTelephone1+"</a>"); 
    
    //search nearest store    
    nearestShop(response.storePostcode)
    
    //binding timings
    $('#store-timing-details td').each(function(){
      let dayName = $(this).attr('name');
      //console.log(dayName+', '+response[dayName])
      $(this).text(response[dayName]);   
    })
  
    //bind service providers
    /*var servicesArr = [];
    
    for (let index = 0; index < 10; index++) {
      let provider = "serviceProvided"+""+index;
      let providerLabel = response[provider];
      providerLabel = providerLabel.replaceAll(' ','-');
      servicesArr.push(response[provider])
      console.log("servicesArr: ",servicesArr)
    }*/
    
    
    
    $('.service-provided-container .serviceProvided').each(function(){
      let provider = $(this).attr('name');
      if(response[provider] != null){
        let responseLabel = response[provider].toLowerCase();
        responseLabel = responseLabel.replaceAll(' ','-');
        let providerLabel = $(this).attr('data-label');
        console.log("label: "+responseLabel+", providerLabel: "+providerLabel)
        if(response[provider] != '' && responseLabel == providerLabel){
          console.log(provider+', '+response[provider])
          //$(this).find('span').text(response[provider]); 
          var pageURL = $(this).attr('data-redirect');
          if(pageURL){
            var storeName = response.storeName
            storeName = storeName.toLowerCase();
            storeName = storeName.replace(' ','-')
            $(this).find('.service-title').html('<a href="'+pageURL+'">'+response[provider]+'</a>');
          }
          else{
            $(this).find('.service-title').text(response[provider]);            
          } 
          $(this).removeClass('hide-item');
        }
      }
    })
  
    //bind paragraphs and Image
    $('#storeImage').attr('src', response.storeImage);
    $('#storeBioParagraph .store-bio').each(function(){
      let paraName = $(this).attr('name');
      //console.log(paraName+', '+response[paraName])
      if(response[paraName] != '' && response[paraName].length > 10){
        $(this).html(response[paraName]); 
        $(this).removeClass('hide-item');
      }else{
        $(this).addClass('hide-item');
      }
    })
    
    //console.log(response);
    //read more/less
    if($('.toggle-read-more').length > 0){
      let dataLen = parseInt($('.toggle-read-more').attr('data-length'));
      let content = $('.toggle-read-more').html();
      let preText = content.substring(0,dataLen);
      //find last closing tag
      dataLen = preText.lastIndexOf('</');
      //update pretext
      preText = content.substring(0,dataLen + 3);
      let postText = content.substring(dataLen + 4, content.length);
      $('.toggle-read-more').html('');
      $('.toggle-read-more').html('<div class="preText">'+preText+'</div><div class="postText" style="display:none;">'+postText+'</div><span class="link_readmore text-red"> Read More</span><span style="display:none;" class="link_readless text-red"> Read Less</span>');
    
      $(document).on('click','.link_readmore', function(){
        $(this).hide();
        $('.link_readless').show();
        $('.postText').show();
      })
      $(document).on('click','.link_readless', function(){
          $(this).hide();
          $('.link_readmore').show();
          $('.postText').hide();
      })
    }

    //binding store location
    storeLocation(response)
  });

  //store details map  
  function storeLocation(response){
    var locations = [
      {
        "storeName": response.storeName,
        "storeLatitude": response.storeLatitude,
        "storeLongitude": response.storeLongitude
      }
    ]
    var grayStyles = [
        {
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e5eafa"
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
            {
              "visibility": "simplified"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#b19459"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#b19459"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.local",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "transit",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#7e8db2"
            }
          ]
        }
      ]
    var map = new google.maps.Map(document.getElementById('map'), {
      zoom: 12,
      styles: grayStyles,
      center: new google.maps.LatLng(locations[0].storeLatitude, locations[0].storeLongitude),
      mapTypeId: google.maps.MapTypeId.ROADMAP
    });    
    var infowindow = new google.maps.InfoWindow();
    var image = "https://cdn.shopify.com/s/files/1/0592/4592/0393/files/marker.png?v=1703080201";
    var marker, i;    
    for (i = 0; i < locations.length; i++) {
      marker = new google.maps.Marker({
        position: new google.maps.LatLng(locations[i].storeLatitude, locations[i].storeLongitude),
        map: map,
        icon: image
      });      
      google.maps.event.addListener(marker, 'click', (function(marker, i) {
        return function() {
          infowindow.setContent(locations[i].storeName);
          infowindow.open(map, marker);
        }
      })(marker, i));
    }
    //$('#map').css('height','calc(100vh - 142px)');
    //$('#map').css('height','calc(100vh)');
  }

  
  
  //find neared stores
  function nearestShop(shop_id) {
    var settings = {
      "async": true,
      "crossDomain": true,
      "url": nearestShop_api+'/'+shop_id,
      "method": "GET"
    } 
    $.ajax(settings).done(function (response) {
      if(response.length > 0){      
        $('.stores-count-result').text(response.length);
        bindStoreList(response);   
        storesListSlider();
      }
    });
  }
    
  //bind store list
  function bindStoreList(response){
    let counter = 0;
    $('.results').html('');
    for(var key in response){
      var obj = response[key];
      //console.log(obj.storeName)
      counter++;
      var storeHandle = obj.storeName;
      storeHandle = storeHandle.toLowerCase().trim();
      storeHandle = storeHandle.replaceAll(' ','-').replace("(","").replace(")","").replace(".","");
      let currentStoreName = $('.store-name').text().trim();
      if(currentStoreName != obj.storeName){
      var storeData =
        `<div class="store-list-item grid__item ">
          <div id="Slide-`+storeHandle+`" class="slider__slide card-body body-2" id="`+obj.storeNumber+`">
            <div class="map-marker"><span>`+counter+`</span></div>            
            <div class="store-details" data-store-id="`+obj.storeNumber+`">
              <!--a href="/pages/`+storeHandle+`?id=`+obj.storeNumber+`" title="`+obj.storeName+`" tabindex="0"-->          
              <div class="store-distance store-distance-1">
                <span class="distance-miles">`+obj.distanceFromTarget+`</span>
                <span>Miles</span>
              </div>
              <a href="/pages/`+storeHandle+`" title="`+obj.storeName+`" tabindex="0">
                <div class="store-name" data-latitude="`+obj.storeLatitude+`" data-longitude="`+obj.storeLongitude+`">                  
                  `+obj.storeName+`  
                  <!--span class="text-red view-store-link">View</span-->
                </div>
              </a>
              <address>
                <div class="store-map"><a target="_blank" href="https://www.google.com/maps/dir/Current+Location/`+obj.storeLatitude+','+obj.storeLongitude+`"><i class="fa-light fa-location-dot"></i> `+obj.fullAddress+`</a></div>
                <!--div class="store-hours">Opening Hours: `+obj.monday+`</div-->
                <a href="/pages/`+storeHandle+`" class="learn-more link animate-arrow">Learn More <span class="icon-wrap"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></span></a>
              </address>
            </div>
          </div>  
        </div>`; 
      }
      $('#search_stores_result.store-results').append(storeData);
      $('#search_stores_result').show();
    }
  }

  //store list slider
  function storesListSlider(){
    $slick_slider = $("[data-slickslider='storelistitem']");
    settings = {
      centerMode: false,
      infinite: true,
      autoplaySpeed:5000,
      cssEase: 'linear',
      slidesToShow: 3,
      slidesToScroll:3,
      dots: true,
      arrows: true,
      adaptiveHeight: true,
      prevArrow:'<i class="slider--arrow PrevArrow fa-thin fa-circle-arrow-left"></i>',
      nextArrow:'<i class="slider--arrow NextArrow fa-thin fa-circle-arrow-right"></i>',
      responsive: [
        {
          breakpoint: 989,
          settings: {
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 520,
          settings: {
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false
          }
        },
        {
          breakpoint: 375,
          settings: {
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false
          }
        }
      ],
    };
    $slick_slider.slick(settings);
  }
})

